import { BaseEntity } from './base.entity';
import { User } from './user.entity';
import { City } from '../../shared/services/cities.service';
import { Type, Transform } from 'class-transformer';

interface LocationPoint {
  lat: number;
  lng: number;
}

export class Address extends BaseEntity {
  street!: string | null;
  city!: string;
  postalCode!: string;
  country!: string;

  @Transform(
    ({ value }) => {
      // Parse locationPoint from backend
      if (typeof value === 'string') {
        // Parse from PostGIS point format "POINT(lng lat)"
        const match = value.match(/POINT\(([-\d.]+)\s+([-\d.]+)\)/);
        if (match) {
          return {
            lng: parseFloat(match[1]),
            lat: parseFloat(match[2]),
          };
        }
      }
      return value;
    },
    { toClassOnly: true }
  )
  @Transform(
    ({ value }) => {
      if (
        value &&
        typeof value === 'object' &&
        'lat' in value &&
        'lng' in value
      ) {
        // Convert to PostGIS point format
        return `POINT(${value.lng} ${value.lat})`;
      }
      return value;
    },
    { toPlainOnly: true }
  )
  locationPoint!: LocationPoint;

  @Type(() => User)
  user?: User;

  static fromCity(city: City): Address {
    const address = new Address();

    address.city = city.label;
    address.postalCode = city.zip_code || '';
    address.country = 'FR'; // Default to France, can be made more flexible if needed

    return address;
  }
}
